import {Component, forwardRef, OnChanges, SimpleChanges, OnInit, ChangeDetectorRef, Injector, ViewChild, OnDestroy} from '@angular/core';
import { NG_VALUE_ACCESSOR, FormControl } from '@angular/forms';
import { DropdownModel } from '../dropdown.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { takeUntil } from 'rxjs/operators';
import { WorkflowComponentsService } from '../../workflow-components.service';
import { ScrollDispatcher } from '@angular/cdk/overlay';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
    selector: 'abw-dropdown-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DropdownFormComponent),
        multi: true
      }
    ],
    templateUrl: './dropdown-form.component.html',
    styleUrls: ['./dropdown-form.component.scss']
})
export class DropdownFormComponent extends AbstractWorkflowFormComponent<DropdownModel, any> implements OnInit, OnChanges {
  searchFormControl = new FormControl('');
  @ViewChild(CdkVirtualScrollViewport) virtualScroll: CdkVirtualScrollViewport;

  constructor(
    protected _workflowComponentsService: WorkflowComponentsService,
    protected _cdf: ChangeDetectorRef,
		protected _injector: Injector,
  ) {
    super(_workflowComponentsService, _cdf, _injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.searchFormControl.valueChanges.pipe(takeUntil(this.onComplete)).subscribe((value: string) => {
      this.datasourceFilteredDatas = value != '' ? this.datasourceDatas.filter(d => !!d && !!d[this.model.displayField] && (d[this.model.displayField] as string).toLowerCase().lastIndexOf(value.toLowerCase()) > -1) : this.datasourceDatas; 
    });
  }

  ngOnChanges(changes: SimpleChanges): void { 
    if (!!changes.model && !!changes.model.currentValue) {
      this.datasourceComponentRefreshed = false;
      setTimeout(() => {
        this.datasourceComponentRefreshed = true;
        try { this._cdf.detectChanges(); } catch(ex) {}
      }, 10);
    }
  }

  handleFilter(value) {
    this.datasourceFilteredDatas = this.model.filteredDatas.filter(
      d => !!d && !!d[this.model.displayField] && d[this.model.displayField].toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
}